import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';

interface IFillingRangeCtrlProps {
  properties: IProperties,
  name: string,
  values: any,
  disabled?:boolean,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

export const FillingRangeCtrl: React.FC<IFillingRangeCtrlProps> = ({ properties, name, setFieldValue, values, disabled }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flexDirection={'row'} justifyContent={'center'}>
        <input
          {...((properties || {}).params || {}).ctrlProps}
          disabled={disabled}
          value={values[name]}
          onChange={(e) => {
            setFieldValue(name, e.target.value);
          }}
        />
        <Text ml={3} alignSelf={'center'}>
          {values[name]}
        </Text>
      </Flex>
    </Flex>);
}